(() => {
  if (customElements.get('kz-products-menu')) return;
  customElements.define('kz-products-menu', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.kz-products-menu__toggle');
      this.panel = this.querySelector('.kz-products-menu__panel');
      if (!this.button || !this.panel) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.button.addEventListener('click', event => {
        if (event.detail > 0 && this.hoverOpened && this.isOpen) this.hoverOpened = false;
        else this.setOpen(!this.isOpen);
      }, options);
      this.addEventListener('pointerenter', event => {
        clearTimeout(this.leaveTimer);
        if (this.isDesktop && event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches && !this.isOpen) {
          this.hoverOpened = true;
          this.setOpen(true);
        }
      }, options);
      this.addEventListener('pointerleave', event => {
        if (!this.isDesktop || event.pointerType !== 'mouse') return;
        this.leaveTimer = setTimeout(() => {
          if (!this.contains(document.activeElement)) this.setOpen(false);
        }, 180);
      }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.setOpen(false);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.target !== this.button || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
        event.preventDefault();
        this.setOpen(true);
        const links = this.panel.querySelectorAll('a[href]');
        (event.key === 'ArrowUp' ? links[links.length - 1] : links[0])?.focus();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.isOpen) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.escapeHandled = true;
        this.setOpen(false);
        this.button.focus({preventScroll: true});
      }, {...options, capture: true});
      document.addEventListener('keyup', event => {
        if (event.key !== 'Escape' || !this.escapeHandled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.escapeHandled = false;
      }, {...options, capture: true});
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.setOpen(false);
        else if (event.target.closest('a[href]')) this.setOpen(false);
      }, options);
      window.addEventListener('resize', () => {
        if (!this.isOpen) return;
        if (!this.button.getClientRects().length) this.setOpen(false);
        else this.positionPanel();
      }, options);
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this) && this.isDesktop) this.setOpen(true);
      }, options);
      document.addEventListener('shopify:section:deselect', () => this.setOpen(false), options);
    }
    get isOpen() { return this.button?.getAttribute('aria-expanded') === 'true'; }
    get isDesktop() { return this.classList.contains('kz-products-menu--desktop'); }
    positionPanel() {
      if (!this.isDesktop) return;
      const rect = this.getBoundingClientRect();
      const width = Math.min(1040, document.documentElement.clientWidth - 48);
      const center = rect.left + rect.width / 2;
      const clamped = Math.max(24 + width / 2, Math.min(center, document.documentElement.clientWidth - 24 - width / 2));
      this.style.setProperty('--kz-menu-shift', (clamped - center) + 'px');
      this.style.setProperty('--kz-menu-height', Math.max(180, window.innerHeight - rect.bottom - 28) + 'px');
    }
    setOpen(open) {
      if (!this.button || this.isOpen === open) return;
      clearTimeout(this.leaveTimer);
      clearTimeout(this.hideTimer);
      cancelAnimationFrame(this.openFrame);
      this.button.setAttribute('aria-expanded', String(open));
      if (open) {
        document.querySelectorAll('kz-products-menu').forEach(menu => {
          if (menu !== this) menu.setOpen(false);
        });
        this.panel.hidden = false;
        this.panel.inert = false;
        this.positionPanel();
        this.panel.getBoundingClientRect();
        this.openFrame = requestAnimationFrame(() => this.setAttribute('data-open', ''));
      } else {
        this.hoverOpened = false;
        this.removeAttribute('data-open');
        this.panel.inert = true;
        const delay = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
        this.hideTimer = setTimeout(() => { this.panel.hidden = true; }, delay);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.hideTimer);
      clearTimeout(this.leaveTimer);
      cancelAnimationFrame(this.openFrame);
    }
  });
})();
